import type { LocaleType } from "lib/apollo/types"
import type { Metadata } from "next"
import { siteUrl } from "utils/getSiteUrl"

export const seoDefaults = {
  title: {
    "en-GB":
      "Beauty Pie | Luxury Makeup & Skincare Products Direct | Beauty Pie",
    "en-US":
      "Beauty Pie | Premium, High-Performance Skincare & Makeup For Less",
  },
  description: {
    "en-GB":
      "Treat yourself better. Join hundreds of thousands of beauty insiders already enjoying premium  skincare, makeup, hair and bodycare, supplements, fragrances and more, direct from the world’s top labs.",
    "en-US":
      "Treat yourself better. Join hundreds of thousands of beauty insiders already enjoying premium  skincare, makeup, hair and bodycare, supplements, fragrances and more, direct from the world’s top labs.",
  },
  url: siteUrl,
  siteName: {
    "en-GB": "Beauty Pie",
    "en-US": "Beauty Pie US",
  },
  entryUrls: {
    "en-GB": "",
    "en-US": "/us",
  },
  localeLinks: {
    "en-GB": siteUrl,
    "en-US": `${siteUrl}/us`,
  },
}

export const createSeoConfig = (locale: LocaleType): Metadata => {
  return {
    title: seoDefaults.title[locale],
    description: seoDefaults.description[locale],
    openGraph: {
      type: "website",
      locale: locale.replace(/-/g, "_"),
      url: seoDefaults.url,
      siteName: seoDefaults.siteName[locale],
      images: [
        {
          url: `${siteUrl}/images/beauty-pie-logo.jpg`,
          alt: "BEAUTY PIE",
          width: 512,
          height: 512,
        },
      ],
    },
    twitter: {
      creator: "@beautypie",
      site: "@beautypie",
      card: "summary_large_image",
    },
    alternates: {
      canonical: seoDefaults.localeLinks[locale],
    },
  }
}
